/**
 *
 * @description webview type 类型
 */

export enum WebviewType {
  _android = 'android',
  _ios = 'ios',
  _h5 = 'h5'
}

export const isAndroid = /Android/i.test(navigator.userAgent)
export const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
export const openAppProtocol = `dingyi://`

/**
 *
 * @description 判断是否 webview
 */
export const getWebviewType = (): WebviewType => {
  const ua = window.navigator.userAgent || ''
  if (ua.indexOf('vipg_android') > -1) {
    return WebviewType._android
  }

  if (ua.indexOf('vipg_ios') > -1) {
    return WebviewType._ios
  }

  return WebviewType._h5
}

export const inApp = getWebviewType() !== WebviewType._h5

// 超链接唤起APP
// url = closePage 关闭页面
export function openApp(url = '') {
  location.href = `${openAppProtocol}` + url
  if (url === 'closePage') {
    return
  }
  const timer = setTimeout(() => {
    // PC端不需要跳转到下载页面
    console.log('App启动失败，PC端不支持')
  }, 1500)
  document.addEventListener(
    'visibilitychange',
    function listener() {
      if (document.hidden) {
        // 页面变为不可见，说明应用被唤起
        clearTimeout(timer)
      }
    },
    { once: true }
  )
}

export const toLoginPage = () => {
  if (inApp) {
    openApp('login')
    // openApp('closePage')
  } else {
    // PC端使用window.location跳转
    window.location.href = '/login'
  }
}
